import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { dateForGoogleCal } from "../../../helpers/date";
import { DefaultButton } from "../Button";

interface IOwnProps {
  open: boolean;
  setDialogOpen: (arg0: boolean) => void;
  scheduledDate: Date | null;
  dsvName: string | null;
  participantName: string | null;
  participantEmail?: string | null;
}

const GoogleCalendarDialog = ({
  open,
  setDialogOpen,
  scheduledDate,
  dsvName,
  participantName,
  participantEmail
}: IOwnProps) => {
  const { t } = useTranslation();

  const handleOkClick = React.useCallback(() => setDialogOpen(false), []);

  return (
    <>
      {scheduledDate ? (
        <Dialog open={open}>
          <DialogTitle>{t("feedback.dialog.title")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("feedback.dialog.googleCalendarDialogMessage")}{" "}
              <a
                href={`https://calendar.google.com/calendar/r/eventedit?action=TEMPLATE&${
                  participantName && dsvName
                    ? `text=${t("feedback.dialog.googleCalendarLink.talkParticipants", {
                        dsvName,
                        participantName
                      })}`
                    : null
                }&dates=${dateForGoogleCal(scheduledDate)}&details=${t(
                  "feedback.dialog.googleCalendarLink.details"
                )}&add=${participantEmail}`}
                target="_blank"
              >
                {t("feedback.dialog.googleCalendarLink")}
              </a>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <DefaultButton onClick={handleOkClick}>{t("feedback.dialog.googleCalendarLink.button.ok")}</DefaultButton>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};
export default React.memo(GoogleCalendarDialog);
